import React from "react";
import SectionCard from "./SectionCard";

const formatCurrency = (amount) => {
  if (amount == null) return "N/A";
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', notation: "compact", maximumFractionDigits: 1 }).format(amount);
};

const TopSponsorsCard = ({
  data,
  title = "Top Sponsors",
  description,
  showAll = false,
  isLoading,
  error,
  isHidden,
  onRetry,
  onSeeMore,
  seeMoreText = "View all",
}) => {
  const topSponsors = data?.items || [];
  const displayList = showAll ? topSponsors : topSponsors.slice(0, 5);
  const defaultDesc = `Based on ${data?.unique_sponsors || 0} total sponsors`;
  
  return (
    <SectionCard
      title={title}
      description={description !== undefined ? description : defaultDesc}
      isLoading={isLoading}
      error={error}
      isHidden={isHidden}
      isEmpty={!topSponsors || topSponsors.length === 0}
      onRetry={onRetry}
      onSeeMore={onSeeMore}
      seeMoreText={seeMoreText}
    >
      <div className={`flex flex-col gap-4 ${showAll ? "max-h-[460px] overflow-y-auto pr-2" : ""}`}>
        {displayList.map((sponsor, idx) => (
          <div key={sponsor.id || idx} className="space-y-1.5 p-2 rounded-lg hover:bg-accent/30 transition-colors">
            <div className="flex justify-between items-start gap-2">
              <span className="font-semibold text-sm line-clamp-1 flex-1 capitalize" title={sponsor.name}>{sponsor.name?.toLowerCase()}</span>
              <div className="flex items-center gap-2">
                <span className="font-bold text-sm whitespace-nowrap text-explore">
                  {formatCurrency(sponsor.total_amount)}
                </span>
              </div>
            </div>
            
            <div className="flex items-center justify-between mt-0.5">
              <p className="text-[11px] text-muted-foreground">
                {sponsor.grant_count} {sponsor.grant_count === 1 ? 'grant' : 'grants'}
              </p>
            </div>
          </div>
        ))}
      </div>
    </SectionCard>
  );
};

export default TopSponsorsCard;
